import { Box, Button, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../../images/willsoar.svg";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import {
  callAPI,
  customValidation,
  Method,
  validations
} from "../../commonFunctions/CommonFunctions";
import { useState } from "react";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { Helmet } from "react-helmet";

export default function ForgotPassword() {
  const { control, handleSubmit, reset } = useForm();
  const { showMessage } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const handleSentResetReq = async (data: any) => {
    try {
      setLoading(true);

      const response: any = await callAPI(
        "auth/forgot/password",
        Method.POST,
        data
      );

      if (response && response?.message) {
        showMessage(response.message, "success");
        reset();
      }
    } catch (error: any) {
       console.error("Failed to connect  with forgot passsword", error);
        if (error.message === 'GlobalHandledError') return;
         showMessage(
        error?.response?.data.message || "An unexpected error occurred",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Forgot Password | Willsoar Technologies</title>
        <meta
          name="description"
          content="Log in to access your estimates, invoices, clients, and more with our powerful estimation tool."
        />
      </Helmet>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          minHeight: "50vh",
          textAlign: "center"
        }}
      >
        {/* Logo Header */}
        <Grid item xs={12} mb={-3}>
          <Box
            sx={{
              mb: 2,
              display: "inline-block",
              px: 4,
              py: 1,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10
            }}
          >
            <img
              src={logo}
              alt="Willsoar Logo"
              style={{
                height: 50,
                objectFit: "contain"
              }}
            />
          </Box>
        </Grid>

        {/* Reset Form Box */}
        <Grid item xs={11} sm={8} md={4}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              padding: 4,
              boxShadow: "0px 4px 15px rgba(0,0,0,0.1)"
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="left"
              mb={2}
              sx={{ color: "#2c3e50" }}
            >
              Reset Password
            </Typography>

            <form onSubmit={handleSubmit(handleSentResetReq)}>
              <WSTextField
                label="E-Mail Address"
                rules={customValidation(true, validations.email)}
                id="email"
                name="email"
                control={control}
              />

              <Button
                fullWidth
                size="small"
                variant="contained"
                sx={{
                  mt: 2,
                  backgroundColor: "#fe6a2c",
                  textTransform: "none",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#e55d1e"
                  }
                }}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Password Reset Link"}
              </Button>
            </form>
          </Box>

          <Typography
            variant="body2"
            sx={{ mt: 2, textAlign: "center", color: "#34495e" }}
          >
            Go back to{" "}
            <Link
              to="/login"
              style={{ color: "#fe6a2c", textDecoration: "none" }}
            >
              Login
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
